import { lastSeen } from '~/helpers/fields-description';
import { NAModule } from '../NAModule.model';

export class NZRE extends NAModule {
    hasOperationDissociate = false;

    get fieldLastSeen() {
        return lastSeen(
            this.last_seen,
            this.outdatedLastSeen ? 'error--text' : '',
        );
    }
}
